import request from '../request'

export default {
    getBaseMap: async () => {
        return request.get('base_mapa')
    },

    getBaseMapTipos: async () => {
        return request.get('base_mapa_tipo')
    },

    getBaseMapCategorias: async () => {
        return request.get('base_mapa_categoria')
    }
}